import { createSelector } from 'reselect';
import { RowFields } from '../Constants';

export const getDateBillSent = (state, props) => {
    return state.interestForm.rowData[props.rowIndex][RowFields.DateBillSent.id].value
}

export const getDateBillPaid = (state, props) => {
    return state.interestForm.rowData[props.rowIndex][RowFields.DatePaid.id].value
}

export const getAmountPaid = (state, props) =>
    state.interestForm.rowData[props.rowIndex][RowFields.AmountPaid.id].value

export const getNumDaysBetween = (date1, date2) => {
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    const diffTime = Math.abs(d2.getTime() - d1.getTime());
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 

    // threshold to 0 if days between is negative
    //  TODO: should instead show errors in form for invalid dates
    diffDays = (diffDays < 0) ? 0 : diffDays; 

    return diffDays;
}

// To whomever reads this function, I'm sorry
export const getInterestAccumulatedForDays = (numDaysBetween, interestPerDay) => numDaysBetween * interestPerDay

// uses 1% for interest rate
export const getInterestPerDay = (amountPaid) => amountPaid * 0.01 / 30;

export const getInterestAccumulated = row => {

        const dateBillSent = row[RowFields.DateBillSent.id].value;
        const datePaid = row[RowFields.DatePaid.id].value;
        const amountPaid = row[RowFields.AmountPaid.id].value;

        if (!dateBillSent || !datePaid || !amountPaid) 
            return [null, null]

        const numDays = getNumDaysSinceInterestStartedAccumulating(dateBillSent, datePaid);
        const interestPerDay = getInterestPerDay(amountPaid)
        
        const interestAccruedUntilPayment = getInterestAccumulatedForDays(numDays, interestPerDay);

        const newInterestPerDay = getInterestPerDay(interestAccruedUntilPayment);
        const totalAsOfToday = interestAccruedUntilPayment + (newInterestPerDay * getNumDaysBetween(datePaid, new Date()));

        return [interestAccruedUntilPayment, totalAsOfToday];
}

const getNumDaysSinceInterestStartedAccumulating = (dateBillSent, dateBillPaid) => {
    const numDaysBetween = getNumDaysBetween(dateBillSent, dateBillPaid);
    return (numDaysBetween - 30) <= 0 ? 0 : numDaysBetween - 30;
}

export const makeGetComputedFields = () => {
    return createSelector(
        [getDateBillSent, getDateBillPaid, getAmountPaid],
        (dateBillSent, dateBillPaid, amountPaid) => {
            const numDaysBetweenSentAndPaid = getNumDaysBetween(dateBillSent, dateBillPaid);
            const interestPerDay = getInterestPerDay(amountPaid);

            const numDaysBetweenInterestStartedAndBillPaid = getNumDaysSinceInterestStartedAccumulating(dateBillSent, dateBillPaid);
            const interestAccruedUntilPayment = getInterestAccumulatedForDays(numDaysBetweenInterestStartedAndBillPaid, interestPerDay);

            const newInterestPerDay = getInterestPerDay(interestAccruedUntilPayment);
            const totalAsOfToday = interestAccruedUntilPayment + (newInterestPerDay * getNumDaysBetween(dateBillPaid, new Date()));

            return {
                numDaysBetweenSentAndPaid,
                interestPerDay,
                interestAccruedUntilPayment,
                totalAsOfToday,
            }
        }
    )
}